import { useState } from "react";
import api from "../api";
import { useTheme } from "../components/Theme";

const Icone = ({ children }) => (
  <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">{children}</svg>
);
const DESTAQUES = [
  ["Pipeline", "Visão completa das vendas", <Icone><rect x="3" y="4" width="5" height="16" rx="1.5"/><rect x="10" y="4" width="5" height="11" rx="1.5"/><rect x="17" y="4" width="4" height="7" rx="1.5"/></Icone>],
  ["Leads", "Qualificados e organizados", <Icone><circle cx="9" cy="8" r="3.5"/><path d="M2.5 20c.8-3.6 3.4-5.5 6.5-5.5s5.7 1.9 6.5 5.5"/><path d="M16 4.5a3.5 3.5 0 0 1 0 7"/><path d="M18.5 14.8c1.7.7 2.7 2.4 3 5.2"/></Icone>],
  ["Dashboard", "Resultados em tempo real", <Icone><path d="M3 20h18"/><path d="M6 16v-4"/><path d="M11 16V8"/><path d="M16 16v-6"/><path d="M21 16V5"/></Icone>],
];

export default function Login({ onLogin, agencia }) {
  const { theme } = useTheme();
  const ORANGE = theme.orange || "#EE6A1A";
  const [form, setForm] = useState({ email: "", senha: "" });
  const [erro, setErro] = useState("");
  const [load, setLoad] = useState(false);
  const [verSenha, setVerSenha] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setErro(""); setLoad(true);
    try {
      const { data } = await api.post("/auth/login", form);
      localStorage.setItem("crm_token", data.token);
      localStorage.setItem("crm_user", JSON.stringify(data.user));
      onLogin(data.user);
    } catch (err) {
      setErro(err.response?.data?.erro || err.response?.data?.message || "Email ou senha incorretos");
    } finally { setLoad(false); }
  };

  const campo = { flex:1, minWidth:0, background:"transparent", border:"none", outline:"none", color:theme.text, fontSize:16, fontFamily:"inherit", padding:0 };
  const caixa = { height:52, display:"flex", alignItems:"center", gap:10, padding:"0 16px", background:theme.bgInput, border:`1.5px solid ${theme.border}`, borderRadius:12, transition:"border-color .15s, box-shadow .15s", boxSizing:"border-box" };
  const foco = (e) => { e.currentTarget.style.borderColor = ORANGE; e.currentTarget.style.boxShadow = `0 0 0 4px ${ORANGE}1F`; };
  const semFoco = (e) => { e.currentTarget.style.borderColor = theme.border; e.currentTarget.style.boxShadow = "none"; };
  const cinza = theme.textMuted;

  return (
    <div style={{ minHeight:"100vh", background:theme.bg, display:"flex", fontFamily:"'Inter',-apple-system,sans-serif" }}>
      <style>{`@media (max-width: 900px){ .login-painel{ display:none !important; } .login-cartao{ padding:28px !important; } }`}</style>

      {/* Painel esquerdo */}
      <div className="login-painel" style={{ flex:"0 0 560px", boxSizing:"border-box", background:`linear-gradient(160deg, ${ORANGE}1F 0%, ${ORANGE}08 60%, transparent 100%)`, borderRight:`1px solid ${theme.border}`, display:"flex", flexDirection:"column", justifyContent:"space-between", padding:"48px 56px" }}>
        <div style={{ display:"flex", alignItems:"center", gap:14 }}>
          <div style={{ width:52, height:52, borderRadius:15, background:ORANGE, display:"flex", alignItems:"center", justifyContent:"center", boxShadow:`0 6px 18px ${ORANGE}4D` }}>
            <svg width="26" height="26" viewBox="0 0 24 24" fill="#fff"><path d="M13 2 4 14h7l-1 8 9-12h-7l1-8z"/></svg>
          </div>
          <div>
            <div style={{ fontWeight:800, fontSize:22, color:theme.text, letterSpacing:"-.02em" }}>Optimus</div>
            <div style={{ fontSize:14, color:cinza }}>CRM de Vendas</div>
          </div>
        </div>

        <div>
          <h1 style={{ fontSize:52, fontWeight:800, color:theme.text, lineHeight:1.08, letterSpacing:"-.03em", margin:"0 0 20px" }}>
            Gerencie suas <span style={{ color:ORANGE }}>oportunidades</span> com inteligência.
          </h1>
          <p style={{ fontSize:18, color:cinza, lineHeight:1.6, maxWidth:400, margin:0 }}>
            Pipeline completo, negociações em tempo real e dashboards para sua equipe de vendas.
          </p>
        </div>

        <div style={{ display:"flex", flexDirection:"column", gap:18 }}>
          {DESTAQUES.map(([n, l, ic]) => (
            <div key={n} style={{ display:"flex", alignItems:"center", gap:16 }}>
              <div style={{ width:44, height:44, borderRadius:12, background:theme.bgInput, border:`1px solid ${ORANGE}33`, color:ORANGE, display:"flex", alignItems:"center", justifyContent:"center", flexShrink:0 }}>{ic}</div>
              <div>
                <div style={{ fontSize:16, fontWeight:700, color:theme.text }}>{n}</div>
                <div style={{ fontSize:14, color:cinza }}>{l}</div>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Painel direito */}
      <div style={{ flex:1, display:"flex", alignItems:"center", justifyContent:"center", padding:24 }}>
        <div className="login-cartao" style={{ width:"100%", maxWidth:440, boxSizing:"border-box", background:theme.bgCard || theme.bgInput, border:`1px solid ${theme.border}`, borderRadius:20, padding:44, boxShadow:"0 20px 50px rgba(30,20,10,.06)" }}>
          <div style={{ marginBottom:28 }}>
            <h2 style={{ fontSize:32, fontWeight:800, color:theme.text, letterSpacing:"-.02em", margin:"0 0 8px" }}>Entrar na conta</h2>
            <p style={{ fontSize:16, color:cinza, margin:0 }}>Bem-vindo de volta!</p>
          </div>

          <form onSubmit={handleSubmit} style={{ display:"flex", flexDirection:"column", gap:18 }}>
            <div>
              <label style={{ fontSize:14, fontWeight:600, color:theme.textSub, display:"block", marginBottom:8 }}>E-mail</label>
              <div style={caixa} onFocus={foco} onBlur={semFoco}>
                <span style={{ color:cinza, display:"flex" }}><svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect x="3" y="5" width="18" height="14" rx="2"/><path d="m3 7 9 6 9-6"/></svg></span>
                <input type="email" autoComplete="email" value={form.email} onChange={e=>setForm(f=>({...f,email:e.target.value}))} required style={campo}/>
              </div>
            </div>
            <div>
              <label style={{ fontSize:14, fontWeight:600, color:theme.textSub, display:"block", marginBottom:8 }}>Senha</label>
              <div style={caixa} onFocus={foco} onBlur={semFoco}>
                <span style={{ color:cinza, display:"flex" }}><svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect x="4" y="10" width="16" height="11" rx="2"/><path d="M8 10V7a4 4 0 0 1 8 0v3"/></svg></span>
                <input type={verSenha ? "text" : "password"} autoComplete="current-password" value={form.senha} onChange={e=>setForm(f=>({...f,senha:e.target.value}))} required style={campo}/>
                <button type="button" onClick={()=>setVerSenha(v=>!v)} title={verSenha ? "Ocultar senha" : "Mostrar senha"} style={{ background:"none", border:"none", padding:4, cursor:"pointer", color:cinza, display:"flex" }}>
                  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M2 12s3.5-7 10-7 10 7 10 7-3.5 7-10 7S2 12 2 12z"/><circle cx="12" cy="12" r="3"/>{verSenha && <path d="M3 3l18 18"/>}</svg>
                </button>
              </div>
            </div>

            {erro && (
              <div style={{ background:"#ef444410", border:"1px solid #ef444430", borderRadius:10, padding:"10px 14px", color:"#ef4444", fontSize:14 }}>{erro}</div>
            )}

            <button type="submit" disabled={load} style={{ height:54, background:ORANGE, border:"none", borderRadius:12, color:"#fff", fontWeight:700, fontSize:17, cursor:load?"not-allowed":"pointer", opacity:load?.8:1, boxShadow:`0 8px 20px ${ORANGE}47`, transition:"transform .15s", marginTop:6, display:"flex", alignItems:"center", justifyContent:"center", gap:8, fontFamily:"inherit" }}
              onMouseEnter={e=>{ if(!load) e.currentTarget.style.transform="translateY(-1px)"; }}
              onMouseLeave={e=>{ e.currentTarget.style.transform="none"; }}>
              {load ? "Entrando..." : "Entrar"}
              {!load && <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round"><path d="M5 12h14"/><path d="m13 6 6 6-6 6"/></svg>}
            </button>
          </form>

          <div style={{ display:"flex", alignItems:"center", gap:12, margin:"26px 0" }}>
            <div style={{ flex:1, height:1, background:theme.border }}/>
            <div style={{ fontSize:13, color:cinza }}>ou</div>
            <div style={{ flex:1, height:1, background:theme.border }}/>
          </div>
          <div style={{ display:"flex", justifyContent:"center", flexWrap:"wrap", gap:6, fontSize:16, color:theme.textSub }}>
            Ainda não tem conta?
            <a href="/cadastro" style={{ color:ORANGE, fontWeight:700, textDecoration:"none" }}>Teste grátis por 7 dias</a>
          </div>
        </div>
      </div>
    </div>
  );
}
